var _path, _path2, _path3, _path4, _path5, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSearchGlass(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.03 34.9855L31.5906 31.5476",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0909 40.7016L39.6599 35.2705C38.4868 34.0974 36.4447 34.0974 35.2716 35.2705C34.6851 35.8571 34.3623 36.6361 34.3623 37.4647C34.3623 38.2933 34.6851 39.0723 35.2716 39.6588L40.7026 45.0899C41.2892 45.6764 42.0682 45.9992 42.8968 45.9992C43.7254 45.9992 44.5044 45.6764 45.0909 45.0899C45.6775 44.5033 46.0002 43.7243 46.0002 42.8957C46.0002 42.0671 45.6775 41.2881 45.0909 40.7016Z",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.8448 36.6897C28.7003 36.6897 36.6897 28.7003 36.6897 18.8448C36.6897 8.9894 28.7003 1 18.8448 1C8.9894 1 1 8.9894 1 18.8448C1 28.7003 8.9894 36.6897 18.8448 36.6897Z",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.396 22.7606H17.2918C17.2918 21.9069 17.9903 21.2085 18.8439 21.2085C19.6976 21.2085 20.396 21.9085 20.396 22.7606Z",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25.828 18.8474C26.2471 18.8474 26.6041 19.2044 26.6041 19.6235C26.6041 20.0425 26.2471 20.3995 25.828 20.3995C25.409 20.3995 25.052 20.0425 25.052 19.6235C25.052 19.2044 25.409 18.8474 25.828 18.8474Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11.8614 18.8474C12.2799 18.8474 12.6364 19.2039 12.6364 19.6224C12.6364 20.0409 12.2799 20.3974 11.8614 20.3974C11.4429 20.3974 11.0864 20.0409 11.0864 19.6224C11.0864 19.2039 11.4429 18.8474 11.8614 18.8474Z",
    fill: "#545454",
    stroke: "#545454",
    strokeWidth: 1.58933,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchGlass);
export default __webpack_public_path__ + "static/media/search-glass.d7a86dd89c597c4905d11ab2535d1ac8.svg";
export { ForwardRef as ReactComponent };